import { defaultTheme, theme } from "@/function/theme";
import { useUserStore } from "@/stores/user";

/**
 * 租户类
 */
export default class Tenant {
    /**
     * 租户Id
     */
    readonly tenantId: string = import.meta.env.VITE_TENANT_ID;

    /**
     * 主题
     */
    private _theme = theme;

    private constructor() {}

    /**
     * 请求接口, 初始化数据
     */
    public async init() {
        const userStore = useUserStore();
        this._theme.setTheme({
            ...defaultTheme,
            systemName: userStore.theme.systemName || defaultTheme.systemName,
            publicHeaderLogo: userStore.theme.systemLogo || defaultTheme.publicHeaderLogo
        });
    }

    /**
     * 获取租户的主题
     */
    get theme() {
        return this._theme;
    }

    /**
     * 单例
     * @private
     */
    private static instance: Tenant;

    /**
     * 获取单例
     */
    static getInstance() {
        if (!Tenant.instance) {
            Tenant.instance = new Tenant();
        }
        return Tenant.instance;
    }
}
